// extracted by mini-css-extract-plugin
export default {"nav":"RegulatorPortalNav_nav__hZ4C6","link":"RegulatorPortalNav_link__3Wsmq","linkActive":"RegulatorPortalNav_linkActive__StMFa"};